import { Campaign, Template } from '../../typings';
import { track } from '../../utils/segment';

export const trackPreviewAnalytics = (template: NonNullable<Template>) => {
  track({
    event: 'Template Preview Requested',
    properties: { category: 'Template', label: template.name },
  });
};

export const trackCampaignCodeCopyAnalytics = (campaign: NonNullable<Campaign>) => {
  track({
    event: 'Campaign Code Copied',
    properties: { category: 'Campaign', label: `${campaign.name} (${campaign.templateId})` },
  });
};
